// removed by extract-text-webpack-plugin
module.exports = {"error-anthentication":"index__error-anthentication___3t8Yk","error-anthentication-msg":"index__error-anthentication-msg___21oqk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/Unauthentication/index.less
// module id = 1956
// module chunks = 3